@if (snippet) {
  <div
    [innerHTML]="snippet"
    class="text-break"></div>
}
@if (!snippet && synopsis) {
  <backstage-ellipsis
    [length]="250"
    [content]="synopsis"/>
}
